var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-row",
        { staticClass: "bg-white" },
        [
          _c("el-col", { attrs: { span: 16 } }, [
            _c("div", { staticClass: "pl-20 pt-10 pb-10 l-b fs-a1" }, [
              _vm._v("编辑服务域名"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pt-30 pl-30" },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: { "label-width": "200px", "label-position": "left" },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "方式：" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.action_type,
                              callback: function ($$v) {
                                _vm.action_type = $$v
                              },
                              expression: "action_type",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "add" } }, [
                              _vm._v("添加"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: "delete" } }, [
                              _vm._v("删除"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: "set" } }, [
                              _vm._v("覆盖"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.type == 1
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "request合法域名：" } },
                              _vm._l(
                                _vm.requestdomain,
                                function (domain, index) {
                                  return _c(
                                    "div",
                                    { staticClass: "mb-10 flex" },
                                    [
                                      _c("el-input", {
                                        staticClass: "mr-15",
                                        model: {
                                          value: _vm.requestdomain[index],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.requestdomain,
                                              index,
                                              $$v
                                            )
                                          },
                                          expression: "requestdomain[index]",
                                        },
                                      }),
                                      _vm._v(" "),
                                      index == 0
                                        ? _c("el-button", {
                                            attrs: {
                                              type: "primary",
                                              icon: "el-icon-plus",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addInput(1, {
                                                  name: "requestdomain",
                                                })
                                              },
                                            },
                                          })
                                        : _c("el-button", {
                                            attrs: {
                                              type: "primary",
                                              icon: "el-icon-minus",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addInput(2, {
                                                  name: "requestdomain",
                                                  key: index,
                                                })
                                              },
                                            },
                                          }),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "socket合法域名：" } },
                              _vm._l(
                                _vm.wsrequestdomain,
                                function (domain, index) {
                                  return _c(
                                    "div",
                                    { staticClass: "mb-10 flex" },
                                    [
                                      _c("el-input", {
                                        staticClass: "mr-15",
                                        model: {
                                          value: _vm.wsrequestdomain[index],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.wsrequestdomain,
                                              index,
                                              $$v
                                            )
                                          },
                                          expression: "wsrequestdomain[index]",
                                        },
                                      }),
                                      _vm._v(" "),
                                      index == 0
                                        ? _c("el-button", {
                                            attrs: {
                                              type: "primary",
                                              icon: "el-icon-plus",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addInput(1, {
                                                  name: "wsrequestdomain",
                                                })
                                              },
                                            },
                                          })
                                        : _c("el-button", {
                                            attrs: {
                                              type: "primary",
                                              icon: "el-icon-minus",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addInput(2, {
                                                  name: "wsrequestdomain",
                                                  key: index,
                                                })
                                              },
                                            },
                                          }),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "uploadFile合法域名：" } },
                              _vm._l(
                                _vm.uploaddomain,
                                function (domain, index) {
                                  return _c(
                                    "div",
                                    { staticClass: "mb-10 flex" },
                                    [
                                      _c("el-input", {
                                        staticClass: "mr-15",
                                        model: {
                                          value: _vm.uploaddomain[index],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.uploaddomain,
                                              index,
                                              $$v
                                            )
                                          },
                                          expression: "uploaddomain[index]",
                                        },
                                      }),
                                      _vm._v(" "),
                                      index == 0
                                        ? _c("el-button", {
                                            attrs: {
                                              type: "primary",
                                              icon: "el-icon-plus",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addInput(1, {
                                                  name: "uploaddomain",
                                                })
                                              },
                                            },
                                          })
                                        : _c("el-button", {
                                            attrs: {
                                              type: "primary",
                                              icon: "el-icon-minus",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addInput(2, {
                                                  name: "uploaddomain",
                                                  key: index,
                                                })
                                              },
                                            },
                                          }),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "downloadFile合法域名：" } },
                              _vm._l(
                                _vm.downloaddomain,
                                function (domain, index) {
                                  return _c(
                                    "div",
                                    { staticClass: "mb-10 flex" },
                                    [
                                      _c("el-input", {
                                        staticClass: "mr-15",
                                        model: {
                                          value: _vm.downloaddomain[index],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.downloaddomain,
                                              index,
                                              $$v
                                            )
                                          },
                                          expression: "downloaddomain[index]",
                                        },
                                      }),
                                      _vm._v(" "),
                                      index == 0
                                        ? _c("el-button", {
                                            attrs: {
                                              type: "primary",
                                              icon: "el-icon-plus",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addInput(1, {
                                                  name: "downloaddomain",
                                                })
                                              },
                                            },
                                          })
                                        : _c("el-button", {
                                            attrs: {
                                              type: "primary",
                                              icon: "el-icon-minus",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addInput(2, {
                                                  name: "downloaddomain",
                                                  key: index,
                                                })
                                              },
                                            },
                                          }),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.seversDomain },
                                  },
                                  [_vm._v("提交")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.type == 2
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "业务域名：" } },
                              _vm._l(
                                _vm.webviewdomain,
                                function (domain, index) {
                                  return _c(
                                    "div",
                                    { staticClass: "mb-10 flex" },
                                    [
                                      _c("el-input", {
                                        staticClass: "mr-15",
                                        model: {
                                          value: _vm.webviewdomain[index],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.webviewdomain,
                                              index,
                                              $$v
                                            )
                                          },
                                          expression: "webviewdomain[index]",
                                        },
                                      }),
                                      _vm._v(" "),
                                      index == 0
                                        ? _c("el-button", {
                                            attrs: {
                                              type: "primary",
                                              icon: "el-icon-plus",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addInput(1, {
                                                  name: "webviewdomain",
                                                })
                                              },
                                            },
                                          })
                                        : _c("el-button", {
                                            attrs: {
                                              type: "primary",
                                              icon: "el-icon-minus",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addInput(2, {
                                                  name: "webviewdomain",
                                                  key: index,
                                                })
                                              },
                                            },
                                          }),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.webDomain },
                                  },
                                  [_vm._v("提交")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }